import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ChessPuzzle from './ChessPuzzleWrapper';
import LandingPage from './LandingPage';
import HomePage from './HomePage';
import AdaptivePuzzlePage from './adaptive/AdaptivePuzzlePage';
import OnboardingPage from './woodpecker/OnboardingPage';
import BriefingPage from './woodpecker/BriefingPage';
import PuzzlePage from './woodpecker/PuzzlePage';
import { WoodpeckerAuthProvider } from './woodpecker/Woodpecker';
import LichessOAuthCallback from './woodpecker/LichessOAuthCallback';
import OpeningLayout from './openings/OpeningLayout';
import OpeningLibrary from './openings/OpeningLibrary';
import OpeningBriefing from './openings/OpeningBriefing';
import OpeningTraining from './openings/OpeningTraining';
import ScrollToTop from './components/ScrollToTop';
import './index.css'

const TrainLanding = lazy(() => import('./social/TrainLanding'));

const OpeningLearner = lazy(() => import('./openings/learner/OpeningLearner'));
const learnerPage = <Suspense fallback={<p role="status">Loading opening theory...</p>}><OpeningLearner /></Suspense>;

// Layout component for Woodpecker routes
function WoodpeckerLayout() {
  return <Outlet />;
}

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/train" element={<Suspense fallback={<p role="status">Loading training...</p>}><TrainLanding /></Suspense>} />
          <Route path="/create" element={<LandingPage />} />
          <Route path="/puzzle" element={<ChessPuzzle />} />
          <Route path="/freeplay" element={<AdaptivePuzzlePage />} />
          <Route path="/openings/learn" element={<OpeningLayout />}>
            <Route index element={learnerPage} />
            <Route path=":openingId" element={learnerPage} />
          </Route>
          <Route path="/openings" element={<WoodpeckerAuthProvider key="openings" basePath="/openings" loadPuzzleData={false}><OpeningLayout /></WoodpeckerAuthProvider>}>
            <Route index element={<OpeningLibrary />} />
            <Route path="sample/:lineId" element={<OpeningTraining />} />
            <Route path="sets/:setId" element={<OpeningBriefing />} />
            <Route path="sets/:setId/train" element={<OpeningTraining />} />
          </Route>

          {/* Woodpecker routes with auth provider */}
          <Route path="/woodpecker" element={
            <WoodpeckerAuthProvider>
              <WoodpeckerLayout />
            </WoodpeckerAuthProvider>
          }>
            <Route index element={<OnboardingPage />} />
            <Route path="briefing" element={<BriefingPage />} />
            <Route path="puzzle" element={<PuzzlePage />} />
            <Route path="oauth/callback" element={<LichessOAuthCallback />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
